export default "__VITE_PUBLIC_ASSET__05c6c1e7__"